import React, { useState, useEffect } from 'react';
import './skillsdropdown.css';

const SkillsDropdown = ({ onSelect, placeholder = "Select or type a skill" }) => {
    const [skills, setSkills] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [customInput, setCustomInput] = useState('');

    useEffect(() => {
        fetchSkills();
    }, []);

    const fetchSkills = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/skills`);
            const data = await response.json();
            setSkills(data);
            const uniqueCategories = [...new Set(data.map(skill => skill.category))];
            setAllCategories(uniqueCategories);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching skills:', error);
            setIsLoading(false);
        }
    };

    const handleSelectChange = (e) => {
        if (e.target.value) {
            onSelect(e.target.value);
            setCustomInput('');
        }
    };

    const handleCustomSubmit = (e) => {
        e.preventDefault();
        if (customInput.trim()) {
            onSelect(customInput.trim());
            setCustomInput('');
        }
    };

    const getFilteredSkills = () => {
        if (selectedCategory) {
            return skills.filter(skill => skill.category === selectedCategory);
        }
        return skills;
    };

    return (
        <div className="flex flex-col gap-2">
            <div className="flex gap-2">
                <select 
                    className="flex-1 p-2 border rounded shadow-sm bg-white"
                    onChange={handleSelectChange}
                    defaultValue=""
                >
                    <option value="" disabled>{isLoading ? 'Loading skills...' : placeholder}</option>
                    {getFilteredSkills().map(skill => (
                        <option key={skill.skill_id} value={skill.skill_name}>
                            {skill.skill_name}
                        </option>
                    ))}
                </select>

                <select 
                    className="w-24 p-2 border rounded shadow-sm bg-white"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                >
                    <option value="">All</option>
                    {allCategories.map(category => (
                        <option key={category} value={category}>
                            {category}
                        </option>
                    ))}
                </select>
            </div>

            <form onSubmit={handleCustomSubmit} className="flex gap-2">
                <input
                    type="text"
                    className="flex-1 p-2 border rounded shadow-sm"
                    placeholder="Or type a custom skill"
                    value={customInput}
                    onChange={(e) => setCustomInput(e.target.value)}
                />
                <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded shadow-sm hover:bg-blue-600 disabled:opacity-50"
                    disabled={!customInput.trim()}
                >
                    Add
                </button>
            </form>
        </div>
    );
};

export default SkillsDropdown;